export default function uppercaseFirst(val: string) {
	return val.charAt(0).toUpperCase() + val.slice(1);
}
